import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { setShowExportHistory } from '@/slices/drawerSlice';

export const useExportHistory = () => {
  const dispatch = useAppDispatch();
  const showHistory = useAppSelector(state => state.drawer.showExportHistory);

  const setShowHistory = useCallback(
    (value: boolean) => {
      dispatch(setShowExportHistory(value));
    },
    [dispatch]
  );

  const toggleHistory = useCallback(() => {
    setShowHistory(!showHistory);
  }, [setShowHistory, showHistory]);

  return { showHistory, setShowHistory, toggleHistory };
};
